import mixpanel from "mixpanel-browser";
import { useCallback } from "react";
import { appLog } from "utils/webview";

/**
 * Hook for sending Mixpanel events only.
 * For setting/identifying Mixpanel People profile properties, use useMixpanelPeople.
 */
export default function useMixpanelWeb(request: {
  params?: { [key: string]: string };
  eventName: string;
}) {
  const params = request.params ? request.params : {};

  const fetchData = useCallback(async () => {
    try {
      console.log("[mixpanel web]", request);
      appLog(`[mixpanel web] ${JSON.stringify(request)}`);

      // Track the event
      mixpanel.track(request.eventName, params);
    } catch (error) {
      console.error("error", error);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [request]);

  return fetchData;
}
